export default {
      id: "moveSeparatorVertical-usage",
      viewBox: "0 0 4 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#moveSeparatorVertical",
      toString: function () {
        return this.url;
      }
    }